<template>
	<div class="redirect-wrap">
		<p>正在跳转到登录页…</p>
	</div>
</template>

<script>
export default {
	name: 'applyLogin',
	created() {
		this.$router.replace({ path: '/login' })
	},
}
</script>

<style scoped>
.redirect-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	color: #666;
}
</style>
